export interface Configs {
  API_URL: string | undefined;
}
const API_URL_RESOLVED = import.meta.env.VITE_APP_API_URL;
console.log("API_URL_RESOLVED", API_URL_RESOLVED);
export const getConfigs = (): Configs => ({
  API_URL:
    API_URL_RESOLVED
});
